
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';

function Counsellor() {
  // return (
  //   <div className="facility-container">
  //     <div className="facility-box">
  //       <h2 className="facility-title">Counsellor </h2>
  //       <p className="facility-text">
  //         Counsellor School psychologists/counsellors are uniquely qualified members of school teams that support students’ ability to learn and teachers’ ability to teach. They apply expertise in mental health, learning, and behaviour, to help children and youth succeed academically, socially, behaviourally, and emotionally. <br />
  //         </p>
  //         <p className="facility-text">
  //           ACE International Academy provides this service as part of the integrated school experience. Our school counsellor extends guidance and support to the children to help polish their character and to achieve academic success as well as guiding the teachers to properly handle in-class behavioural issues. <br />
  //         </p>
  //         <p className="facility-text">
  //           We also have external links to other health and well being professionals in the twin cities.
  //         </p>

  //     </div>
  //   </div>
  // );
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    <Container className="my-5">
      <Row>
        <Col xs={6} md={5}>
          <div data-aos="flip-left" data-aos-duration="2500">
            <Image
              src="imagesspecialfacilities/Counsellor.jpg"
              rounded
              style={{ width: '100%', objectFit: 'cover', marginTop: '30px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
            />
          </div>
        </Col>
        <Col xs={6} md={7}>
          <div className="facility-text">
            <h2 className="facility-title">Counsellor</h2>
            <br />
            <p>
              School psychologists/counsellors are uniquely qualified members of school teams that support students’ ability to learn and teachers’ ability to teach. They apply expertise in mental health, learning, and behaviour, to help children and youth succeed academically, socially, behaviourally, and emotionally.
            </p>
            <p>ACE International Academy provides this service as part of the integrated school experience. Our school counsellor extends guidance and support to the children to help polish their character and to achieve academic success as well as guiding the teachers to properly handle in-class behavioural issues.</p>
            <p>We also have external links to other health and well being professionals in the twin cities.</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={12}>
          <div className="facility-text">

          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Counsellor;
